import PostCulpritButton from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/culprit/correctiveImages/components/inquiredCulpritForm/components/postButton/PostCulpritButton';
import InquiredCulpritFormTabs from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/culprit/correctiveImages/components/inquiredCulpritForm/components/tabs/InquiredCulpritFormTabs';
import InquiredFormList from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/components/correctiveImages/list/InquiredFormList';
import { getCulpritPreviousCorrectiveImagesOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritPreviousCorrectiveImages/getCulpritPreviousCorrectiveImagesOptions';
import { useCorrectiveImages } from '@/modules/adjusterReportModules/IncidentParticipants/store/correctiveImages/useCorrectiveImages';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

const InquiredCulpritCorrectiveForm = () => {
  const { id } = useParams();
  const { data } = useQuery(
    getCulpritPreviousCorrectiveImagesOptions({ id: +id! }),
  );
  const { setPreFetchedCorrectiveImages } = useCorrectiveImages();

  useEffect(() => {
    if (data) {
      setPreFetchedCorrectiveImages(data);
    }
  }, [data]);

  return (
    <Box display={'flex'} flexDirection={'column'} gap={24}>
      <InquiredCulpritFormTabs />
      <InquiredFormList />
      <PostCulpritButton />
    </Box>
  );
};

export default InquiredCulpritCorrectiveForm;
